// Roadmap.js
import React from 'react';
import '../styles/Roadmap.css'; // external CSS file


const Roadmap = () => {
  return (
    <div className="roadmap-container">
      <h1>Roadmap</h1>
    </div>
  );
};

export default Roadmap;
